import { render, staticRenderFns } from "./modifyBatchServer.vue?vue&type=template&id=622bc67c&scoped=true&"
import script from "./modifyBatchServer.vue?vue&type=script&lang=js&"
export * from "./modifyBatchServer.vue?vue&type=script&lang=js&"
import style0 from "./modifyBatchServer.vue?vue&type=style&index=0&id=622bc67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622bc67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('622bc67c')) {
      api.createRecord('622bc67c', component.options)
    } else {
      api.reload('622bc67c', component.options)
    }
    module.hot.accept("./modifyBatchServer.vue?vue&type=template&id=622bc67c&scoped=true&", function () {
      api.rerender('622bc67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/components/modifyBatchServer.vue"
export default component.exports